var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNairaLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66666 17V7.87667C7.66661 7.68277 7.73095 7.49435 7.8496 7.34099C7.96824 7.18763 8.13447 7.07802 8.32216 7.02938C8.50986 6.98074 8.70839 6.99582 8.88659 7.07226C9.06478 7.14869 9.21254 7.28215 9.30666 7.45167L14.36 16.5483C14.4541 16.7179 14.6019 16.8513 14.7801 16.9277C14.9583 17.0042 15.1568 17.0193 15.3445 16.9706C15.5322 16.922 15.6984 16.8124 15.8171 16.659C15.9357 16.5057 16 16.3172 16 16.1233V7M6 10.3333H17.6667M6 13.6667H17.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNairaLight);
export default __webpack_public_path__ + "static/media/naira-light.01fd9b4d53be3f8edeb0bc7653c105c8.svg";
export { ForwardRef as ReactComponent };